import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: 'input[type=number]',
    standalone: false
})
export class DisableNumberInputScrollDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    event.preventDefault();
  }
}
